import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

// Renders a member badge. Image badges (the original ones) render their PNG and
// fall back to an emoji if the image fails; newer badges (LinkedIn, Connector,
// Class of YYYY, etc.) are emoji-only — no image asset required.
const Badge = ({ badge, size = 'small', showTooltip = true }) => {
  const sizeClasses = {
    tiny: 'w-4 h-4 text-[10px]',
    small: 'w-6 h-6 text-sm',
    medium: 'w-8 h-8 text-base',
    large: 'w-12 h-12 text-2xl'
  };
  const badgeClass = sizeClasses[size] || sizeClasses.small;
  const badgeId = `badge-${badge.id}`;
  const tooltip = badge.tooltipDescription || badge.name;
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <div className="inline-block align-middle">
      {badge.image && !imgFailed ? (
        // Real PNG badge artwork (preferred whenever an image exists).
        <img
          src={`${process.env.PUBLIC_URL}${badge.image}`}
          alt={badge.name}
          className={`${badgeClass} object-contain`}
          data-tooltip-id={showTooltip ? badgeId : undefined}
          data-tooltip-content={showTooltip ? tooltip : undefined}
          onError={() => setImgFailed(true)}
        />
      ) : badge.emoji ? (
        // Emoji fallback — only for badges without artwork (or if a PNG is missing).
        <span
          className={`${badgeClass} inline-flex items-center justify-center rounded-full bg-blue-50 leading-none`}
          role="img"
          aria-label={badge.name}
          data-tooltip-id={showTooltip ? badgeId : undefined}
          data-tooltip-content={showTooltip ? tooltip : undefined}
        >
          {badge.emoji}
        </span>
      ) : null}
      {showTooltip && <Tooltip id={badgeId} place="top" effect="solid" />}
    </div>
  );
};

export default Badge;
